/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
/*global console*/

expocadfx.Favorites = function() {
	'use strict';
    var data = expocadfx.fxData;
    var storage = expocadfx.localStorage.storageAvailable( "localStorage");
    
    var lsFavs = "";
    
    
    function init( event) {
        var favStr = "";
        lsFavs = event + "_favs";
        
        if( storage) {
            favStr = storage.getItem( lsFavs);      //  new storage
            if( favStr) {
                data.favoriteBooths = JSON.parse( favStr);
            }
        }
        else {
            console.log( "Local storage access denied  ");
        }
    }
    
    /*
    *   For each booth number, Add exhibitor id and booth number pair to local storage
    *   exhibitor:      the id of a single exhibitor.
    *   boothNumbers:   comma separated string on booth numbers
    */
    function saveFavorite( boothNumbers, exhibitor) {
        var arNumbers = boothNumbers.split(",");
        var numLen = arNumbers.length;
        var i;
        var favLen;
        var index;
        var found = false;
        
        for( i = 0; i < numLen; i++) {
            //  is pair in array ??
            found = false;
            favLen = data.favoriteBooths.length;
            for( index = 0; index < favLen; index++) {
                // is it already a fav ??
                if( data.favoriteBooths[index].bth === arNumbers[i] &&
                        data.favoriteBooths[index].exh === exhibitor) {
                    found = true;
                    break;
                }
            }
            if( !found) {
                data.favoriteBooths.push( { bth: arNumbers[i], exh: exhibitor});
            }
        }
        if( storage) {
            storage.setItem( lsFavs, JSON.stringify( data.favoriteBooths));
        }
        else {
            console.log( "Save favorite to local storage failed");   
        }
    }
    
    /*
    *   exhibitor:      the id of a single exhibitor.
    *   boothNumbers:   comma separated string on booth numbers
    */
    function removeFavorite( boothNumbers, exhibitor) {
        var arNumbers = boothNumbers.split(",");
        var numLen = arNumbers.length;
        var i;
        var favLen;
        var index;
        
        for( i = 0; i < numLen; i++) {
            favLen = data.favoriteBooths.length;
            for( index = 0; index < favLen; index++) {
                if( data.favoriteBooths[index].bth === arNumbers[i] &&
                    data.favoriteBooths[index].exh === exhibitor) {
                    data.favoriteBooths.splice( index, 1);
                    break;
                }
            }
        }
        
        if ( storage) {
            if( data.favoriteBooths.length === 0) {
                storage.removeItem( lsFavs);
            }
            else {
                storage.setItem( lsFavs, JSON.stringify( data.favoriteBooths));
            }
        }
    }
    
    function validateFavorites( booths) {
            //  On open, make sure favorites still exist in the event
            // if multi-view: booths = eventBooths,  else booths = data.exhibitors
        var numFavs = data.favoriteBooths.length;
        var i;
        var change = false;
        
        if( !storage) {
            return;
        }
        
        function favInArray( bthNum, exhId) {
            var index = 0;
			
            for( index = 0; index < booths.length; index++) {
				if( booths[ index].boothNumber === bthNum && booths[ index].exhId === exhId) {
					booths[ index].favorite = true;
					return true;
				}
            }
            return false;
        }
		
		
        
		for( i = 0; i < numFavs; i++) {
			if( !favInArray( data.favoriteBooths[i].bth, data.favoriteBooths[i].exh, null)) {
				data.favoriteBooths.splice( i, 1);
				i -= 1;
				numFavs = data.favoriteBooths.length;
				change = true;
			}
		}
        
        if( data.favoriteBooths.length === 0) {
            storage.removeItem( lsFavs);
        }
        else {
            if( change) {
                storage.setItem( lsFavs, JSON.stringify( data.favoriteBooths));
            }
        }
    }
    
    return {
        init: init,
        remove: removeFavorite,
        save: saveFavorite,
        validate : validateFavorites
    };
};